/**
 * Глобальный обработчик кнопки "Назад" для попапов в мобильном WebView.
 * Должен быть инициализирован ДО создания React приложения.
 */

import { generateId } from './generateId';
import { isMobileWebView } from './nativeEnv';

type PopupEntry = {
  id: string;
  onClose: VoidFunction;
};

const popupStack: PopupEntry[] = [];

let initialized = false;

/**
 * Инициализирует глобальный обработчик кнопки "Назад".
 * Регистрирует JavaScript функции, которые Flutter может вызывать.
 * Вызывать в main.tsx до createRoot.
 */
export const initPopupBackButtonHandler = () => {
  if (initialized) {
    return;
  }

  initialized = true;

  /**
   * Функция, которую Flutter должен вызывать при нажатии системной кнопки "Назад".
   * Возвращает true, если попап был открыт и закрыт, дополнительных действий не требуется.
   * Возвращает false, если открытых попапов нет, нужно выполнить стандартный goBack().
   */
  window.onBackPressed = (): boolean => {
    if (popupStack.length > 0) {
      const popup = popupStack.pop();

      popup?.onClose();

      return true;
    }

    return false;
  };

  /**
   * Функция для проверки, есть ли открытый попап.
   */
  window.hasOpenPopup = (): boolean => {
    return popupStack.length > 0;
  };
};

/**
 * Регистрирует попап в стеке.
 * Возвращает функцию для удаления попапа из стека.
 */
export const registerPopup = (onClose: VoidFunction): (() => void) => {
  if (!isMobileWebView()) {
    return () => {};
  }

  const popupId = generateId();

  popupStack.push({
    id: popupId,
    onClose,
  });

  return () => {
    const index = popupStack.findIndex((p) => p.id === popupId);

    if (index !== -1) {
      popupStack.splice(index, 1);
    }
  };
};
